import { useState, useRef, useEffect } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useLang } from "@/i18n/LangContext";

export function LanguageSwitcher({ light = false }) {
  const { lang, setLang, languages } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find((l) => l.code === lang) || languages[0];

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((v) => !v)} data-testid="dealer-lang-select"
        className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm font-semibold transition-colors ${light ? "text-white/90 hover:bg-white/10" : "text-slate-600 hover:bg-slate-100"}`}>
        <Globe size={16} />
        <span className="hidden sm:inline">{current.native}</span>
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-44 bg-white rounded-xl border border-slate-200 shadow-xl py-1.5 z-50 fade-up" data-testid="dealer-lang-menu">
          {languages.map((l) => (
            <button key={l.code} onClick={() => { setLang(l.code); setOpen(false); }}
              data-testid={`dealer-lang-${l.code}`}
              className={`w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-slate-50 ${l.code === lang ? "text-[#00529B] font-semibold" : "text-slate-600"}`}>
              <span>{l.native}<span className="text-slate-300 ml-1.5 text-xs">{l.label}</span></span>
              {l.code === lang && <Check size={15} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
